var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/* tslint:disable: class-name */
/*
 * AUTOGENERATED FILE - DO NOT EDIT
 */
import { ewJSONDepartment } from './ewJSONDepartment';
import { ewJSONGren } from './ewJSONGren';
import { ewJSONSal } from './ewJSONSal';
import { JSONStruct, array_property } from 'badphraim/data/JSONStruct';
export class ewJSONFilters extends JSONStruct {
    constructor() {
        super(...arguments);
        /** @override */ this.avdelinger = [];
        /** @override */ this.grener = [];
        /** @override */ this.saler = [];
    }
}
__decorate([
    array_property(ewJSONDepartment),
    __metadata("design:type", Array)
], ewJSONFilters.prototype, "avdelinger", void 0);
__decorate([
    array_property(ewJSONGren),
    __metadata("design:type", Array)
], ewJSONFilters.prototype, "grener", void 0);
__decorate([
    array_property(ewJSONSal),
    __metadata("design:type", Array)
], ewJSONFilters.prototype, "saler", void 0);
